import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import moment from 'moment-timezone'

import type { RootState } from '../index'
import { apiGET } from '../lib/api'
import { createTrainId, TrainInstance } from '../reducers/wagonSlice'

type FetchTrainDataParams = {
  trainNumber: string
  businessDate: string
}

type FetchTrainDataError = {
  message: string
}

const normalizeDate = (date: string): string =>
  date.includes('.') ? moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD') : date

// Fetch train wagon data from API
export const fetchTrainDataAction = createAsyncThunk<
  TrainInstance,
  FetchTrainDataParams,
  { rejectValue: FetchTrainDataError; state: RootState }
>(
  '/wagons',
  async ({ trainNumber, businessDate }, thunkApi) => {
    try {
      const normalizedDate = normalizeDate(businessDate)
      return await apiGET<TrainInstance>(
        `/wagons?trainNumber=${trainNumber}&trainDate=${normalizedDate}`
      )
    } catch (err) {
      if (err instanceof AxiosError && err.response?.status === 404) {
        return {
          trainNumber,
          businessDate,
          trainParts: null,
        }
      }

      return thunkApi.rejectWithValue({
        message: err instanceof Error ? err.message : 'Failed to fetch train data',
      })
    }
  },
  {
    condition: ({ trainNumber, businessDate }, { getState }) => {
      const state = getState()
      const trainId = createTrainId(trainNumber, businessDate)
      const existing = state.wagonSection.fetchedTrains[trainId]

      return !existing || existing.state === 'error'
    },
  }
)
